module.exports = __webpack_public_path__ + "img/Fullscreen_selected.0a5d7a23.svg";